/*
  CNC buy box – Motion theme overrides
  ---------------------------------------------------------------------------
  Part 1 – Pre-order label (Task 4)
    Variants with policy "continue" and quantity <= 0 show the pre-order
    label instead of "Auf Lager". Label text comes from data-preorder-label
    on [data-product-inventory] (section setting cnc_preorder_label).
 
  Part 2 – Variant note (Task 2)
    Shows/hides [data-cnc-variant-note] when the selected variant has an
    option value containing one of the words in data-cnc-triggers
    (comma-separated, case-insensitive, whole word: "Sand" matches
    "Sand", "2x Sand", "4x Sand", "Sand / Beige" – not "Sandbraun").
 
  Part 3 – Swatch app placement (Task 2)
    Swatch apps (Rio, GloboSwatch) hide the theme's Variant picker block (display: none) and
    renders its own swatches. The note lives inside that hidden block, so it
    is moved directly below the visible swatch group for the same option.
    The note is placed after the app's block (never inside it), kept in a
    registry and re-inserted if an app re-render removes it.
 
  Loaded after theme.min.js in layout/theme.liquid.
*/
(function() {
  'use strict';
 
  /* =========================================================================
     Part 1 – Pre-order label
     ========================================================================= */
 
  var PREORDER_FALLBACK = 'Vorbestellbar';
 
  function getInventoryData(instance, variantId) {
    var productInventories = window.inventories && window.inventories[instance.productId];
    if (productInventories && productInventories[variantId]) {
      return productInventories[variantId];
    }
 
    // Fallback for quick view / JS-loaded products
    var dataEl = instance.container.querySelector('.js-variant-inventory-data[data-id="' + variantId + '"]');
    if (dataEl) {
      return {
        quantity: dataEl.dataset.quantity,
        policy: dataEl.dataset.policy
      };
    }
 
    return null;
  }
 
  function isPreorder(data) {
    if (!data) return false;
    var quantity = parseInt(data.quantity, 10);
    return data.policy === 'continue' && !isNaN(quantity) && quantity <= 0;
  }
 
  function applyPreorderLabel(instance, variant) {
    if (!instance || !instance.container || !variant) return;
 
    var el = instance.container.querySelector('[data-product-inventory]');
    if (!el) return;
 
    var wrapper = el.parentNode;
    var data = getInventoryData(instance, variant.id);
 
    if (isPreorder(data)) {
      wrapper.classList.remove('inventory--low');
      wrapper.classList.add('inventory--preorder');
      el.textContent = el.dataset.preorderLabel || PREORDER_FALLBACK;
    } else {
      wrapper.classList.remove('inventory--preorder');
    }
  }
 
  function patchProduct() {
    if (!window.theme || !theme.Product || !theme.Product.prototype) return false;
 
    var proto = theme.Product.prototype;
    if (proto.__cncPreorderPatched) return true;
 
    var original = proto.toggleInventoryQuantity;
    if (typeof original !== 'function') return false;
 
    proto.toggleInventoryQuantity = function(variant, show, qty) {
      original.apply(this, arguments);
      applyPreorderLabel(this, variant);
    };
 
    proto.__cncPreorderPatched = true;
    return true;
  }
 
  /* =========================================================================
     Part 2 – Variant note visibility
     ========================================================================= */
 
  var NOTE_SELECTOR = '[data-cnc-variant-note]';
 
  // Lowercase, separators to spaces, padded – for whole-word matching
  function padWords(value) {
    var clean = String(value == null ? '' : value)
      .toLowerCase()
      .replace(/[\/\-,()+&.:|_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return ' ' + clean + ' ';
  }
 
  function getTriggers(note) {
    return (note.getAttribute('data-cnc-triggers') || '')
      .split(',')
      .map(function(t) { return t.trim().toLowerCase().replace(/\s+/g, ' '); })
      .filter(Boolean);
  }
 
  function valueMatches(value, triggers) {
    var padded = padWords(value);
    for (var i = 0; i < triggers.length; i++) {
      if (padded.indexOf(' ' + triggers[i] + ' ') > -1) return true;
    }
    return false;
  }
 
  function getContainer(el) {
    if (!el || !el.closest) return null;
    return el.closest('[data-section-type="product"]') || el.closest('.product-section');
  }
 
  // Cached on the JSON element itself, so swapped-in products get fresh data
  function getVariants(container) {
    var jsonEl = container.querySelector('[data-variant-json]');
    if (!jsonEl) return null;
    if (jsonEl.__cncVariants) return jsonEl.__cncVariants;
 
    try {
      jsonEl.__cncVariants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
 
    return jsonEl.__cncVariants;
  }
 
  // Selected option values: the variant in the hidden id select is what goes
  // into the cart, so use it first. Fall back to the visible inputs.
  function getSelectedValues(container) {
    var idInput = container.querySelector('[data-product-select]') ||
                  container.querySelector('form[action*="/cart/add"] [name="id"]');
    var variants = getVariants(container);
 
    if (idInput && variants && idInput.value) {
      var id = String(idInput.value);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) {
          return variants[i].options || [];
        }
      }
    }
 
    var values = [];
    container.querySelectorAll('[data-variant-input]').forEach(function(input) {
      if (input.tagName === 'SELECT') {
        values.push(input.value);
      } else if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) {
        values.push(input.value);
      }
    });
 
    return values;
  }
 
  function updateNote(note) {
    var container = note.__cncContainer || getContainer(note);
    if (!container) return;
 
    var triggers = getTriggers(note);
    var match = getSelectedValues(container).some(function(value) {
      return valueMatches(value, triggers);
    });
 
    note.classList.toggle('is-visible', match);
    note.setAttribute('aria-hidden', match ? 'false' : 'true');
  }
 
  function updateNotesIn(scope) {
    (scope || document).querySelectorAll(NOTE_SELECTOR).forEach(updateNote);
  }
 
  function scheduleUpdate(scope, delay) {
    setTimeout(function() {
      updateNotesIn(scope);
    }, delay || 0);
  }
 
  function onInteraction(evt) {
    var container = getContainer(evt.target);
    if (!container || !container.querySelector(NOTE_SELECTOR)) return;
 
    // Let the theme (or a swatch app) update the selection first
    scheduleUpdate(container, 0);
    scheduleUpdate(container, 120);
    scheduleUpdate(container, 400);
  }
 
  // Capture phase so it runs regardless of other handlers stopping propagation
  document.addEventListener('change', onInteraction, true);
  document.addEventListener('click', onInteraction, true);
 
  // Theme event (fires before the hidden id select is updated, so defer)
  document.addEventListener('variant:change', function() {
    scheduleUpdate(document, 0);
  });
 
  /* =========================================================================
     Part 3 – Keep the note visible next to a swatch app
     ---------------------------------------------------------------------------
     Swatch apps (Rio / GloboSwatch) hide the theme's Variant picker block
     (display: none) and draw their own swatches. The note is rendered inside
     that hidden block, so it is moved to sit right AFTER the app's whole
     block – never inside it, because React-based apps delete foreign nodes
     inside their own markup when they re-render.
     Every note is also kept in a registry: if anything removes it from the
     page, it is put back.
     ========================================================================= */
 
  var registry = [];
 
  function isRendered(el) {
    return el.getClientRects().length > 0;
  }
 
  // True if el or one of its ancestors is display:none
  function isInsideHidden(el) {
    var p = el;
    while (p && p !== document.body) {
      if (getComputedStyle(p).display === 'none') return true;
      p = p.parentElement;
    }
    return false;
  }
 
  // Option name of the theme picker rendered right before the note, e.g. "Farbe"
  function readOptionName(note) {
    if (note.dataset.cncOption) return note.dataset.cncOption;
 
    var prev = note.previousElementSibling;
    var name = '';
 
    if (prev) {
      var fieldset = prev.querySelector('fieldset[name]');
      var select = prev.querySelector('select[data-variant-input]');
      var label = prev.querySelector('.variant__label');
 
      if (fieldset) {
        name = fieldset.getAttribute('name');
      } else if (select && select.options.length && select.options[0].getAttribute('name')) {
        name = select.options[0].getAttribute('name');
      } else if (label && label.childNodes.length) {
        name = label.childNodes[0].textContent;
      }
    }
 
    name = String(name || '').trim();
    if (name) note.dataset.cncOption = name;
    return name;
  }
 
  function register(note) {
    if (registry.indexOf(note) > -1) return;
 
    note.__cncContainer = getContainer(note);
    note.__cncHome = note.parentElement;   // theme Variant picker block
    readOptionName(note);                  // must run before any move
    registry.push(note);
  }
 
  // Visible label of the swatch app for this option ("FARBE: 2X SAND")
  function findVisibleOptionLabel(container, optionName, home) {
    var name = optionName.toLowerCase();
    var best = null;
 
    container.querySelectorAll('label, legend, span, div, p, strong, b, h3, h4, h5').forEach(function(el) {
      if (home && home.contains(el)) return;
      if (el.closest(NOTE_SELECTOR)) return;
 
      var text = (el.textContent || '').trim().toLowerCase();
      if (!text || text.length > 80 || text.indexOf(name) !== 0) return;
 
      // "Farbe", "Farbe:", "Farbe: Sand" match – "Farbenfroh" does not
      var next = text.charAt(name.length);
      if (next && /[a-z0-9äöüß]/.test(next)) return;
 
      if (!isRendered(el)) return;
 
      // Keep the deepest match (document order lists parents first)
      if (!best || best.contains(el)) best = el;
    });
 
    return best;
  }
 
  // Top-level element of the swatch app: climb from its label until the
  // parent is the area that also holds the theme's picker block.
  function findAppBlock(label, home) {
    var el = label;
    while (el.parentElement && !el.parentElement.contains(home)) {
      el = el.parentElement;
    }
    return el;
  }
 
  function placeNote(note) {
    var container = note.__cncContainer;
    var home = note.__cncHome;
    if (!container || !container.isConnected) return;
 
    var homeHidden = home && home.isConnected && isInsideHidden(home);
 
    // No swatch app: keep / put the note back in the theme picker block
    if (!homeHidden) {
      if (!note.isConnected && home && home.isConnected) home.appendChild(note);
      return;
    }
 
    var optionName = readOptionName(note);
    if (!optionName) return;
 
    var label = findVisibleOptionLabel(container, optionName, home);
    if (!label) return;
 
    var appBlock = findAppBlock(label, home);
    if (!appBlock.parentNode) return;
 
    if (appBlock.nextElementSibling !== note) {
      appBlock.parentNode.insertBefore(note, appBlock.nextSibling);
    }
 
    note.classList.add('cnc-variant-note--relocated');
  }
 
  function refreshAll() {
    document.querySelectorAll(NOTE_SELECTOR).forEach(register);
 
    // Drop notes whose product section is gone (e.g. closed quick view)
    registry = registry.filter(function(note) {
      return note.__cncContainer && note.__cncContainer.isConnected;
    });
 
    registry.forEach(function(note) {
      placeNote(note);
      if (note.isConnected) updateNote(note);
    });
  }
 
  // One page-wide watcher: swatch apps render late, and the size switcher /
  // quick view / section reloads swap in new product markup.
  var refreshTimer = null;
  var refreshing = false;
 
  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      refreshing = true;
      try {
        refreshAll();
      } finally {
        // Ignore the mutations caused by our own move
        setTimeout(function() { refreshing = false; }, 0);
      }
    }, delay == null ? 120 : delay);
  }
 
  function startObserver() {
    if (!document.body || startObserver.done) return;
    startObserver.done = true;
 
    var observer = new MutationObserver(function(mutations) {
      if (refreshing) return;
      if (!registry.length && !document.querySelector(NOTE_SELECTOR)) return;
 
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length || mutations[i].removedNodes.length || mutations[i].type === 'attributes') {
          scheduleRefresh();
          return;
        }
      }
    });
 
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
 
  /* =========================================================================
     Init
     ========================================================================= */
 
  function init() {
    patchProduct();
    startObserver();
    refreshAll();
  }
 
  if (!patchProduct()) {
    document.addEventListener('DOMContentLoaded', patchProduct);
    document.addEventListener('page:loaded', patchProduct);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Swatch apps usually finish after window load
  window.addEventListener('load', function() {
    scheduleRefresh(0);
    setTimeout(function() { scheduleRefresh(0); }, 800);
    setTimeout(function() { scheduleRefresh(0); }, 2000);
  });
 
  // Quick view, theme editor section reloads, back/forward
  document.addEventListener('quickview:loaded', function() { scheduleRefresh(0); });
  document.addEventListener('shopify:section:load', function() { scheduleRefresh(0); });
  window.addEventListener('popstate', function() { scheduleRefresh(150); });
  window.addEventListener('pageshow', function() { scheduleRefresh(0); });
 
  // Some scripts change the variant without firing events (they only set the
  // select value or the URL). A light check of the selected variant id + URL
  // catches those; it does no DOM work unless something changed.
  var lastSignature = '';
 
  function selectionSignature() {
    var parts = [location.search];
    registry.forEach(function(note) {
      var container = note.__cncContainer;
      if (!container) return;
      var idInput = container.querySelector('[data-product-select]') ||
                    container.querySelector('form[action*="/cart/add"] [name="id"]');
      parts.push(idInput ? idInput.value : '');
      parts.push(note.isConnected ? '1' : '0');
    });
    return parts.join('|');
  }
 
  setInterval(function() {
    if (document.hidden || !registry.length) return;
    var signature = selectionSignature();
    if (signature !== lastSignature) {
      lastSignature = signature;
      scheduleRefresh(0);
    }
  }, 400);
})();